import { defineMessages } from 'react-intl';

export const formMapMessages = defineMessages({
  submitButton: {
    id: 'formMap.submitButton',
    defaultMessage: 'Submit',
    description: 'Form map submit button',
  },
  cancelButton: {
    id: 'formMap.cancelButton',
    defaultMessage: 'Cancel',
    description: 'Form map cancel button',
  },
});
